import { render, staticRenderFns } from "./LeadColor.vue?vue&type=template&id=6d8ce489"
import script from "./LeadColor.vue?vue&type=script&lang=js"
export * from "./LeadColor.vue?vue&type=script&lang=js"
import style0 from "./LeadColor.vue?vue&type=style&index=0&id=6d8ce489&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports